var utils = require('lib/utils');

var EnrollmentDataService = {
  saveData: function(key, data){
    var options = {
      success: function(){
        Chaplin.mediator.publish('enrollment-data-saved:' + key, data);
      },
      error: function(){
        Chaplin.mediator.publish('enrollment-data-failed:' + key, data);
      }
    };
    EF.enrollment.setData(key, data, options);
  },
  getByDotString: function(dotString) {
    let rawData = dotString.split('.');
    let key = rawData.shift();
    let enrollmentObject = this.getData(key);

    if (enrollmentObject) {
      return rawData.length === 0 ? enrollmentObject : utils.dotStringToObject(rawData.join('.'), enrollmentObject);
    }
  },
  getData: function(key, options = {}){
    var data;
    if(EF.enrollment && EF.enrollment.attributes){
      data = EF.enrollment.getData(key);
    }
    Chaplin.mediator.publish('enrollment-data-loaded:' + key, data);
    if (data !== undefined && data !== null){
      return data;
    } else if (options.defaultValue !== undefined) {
      return options.defaultValue;
    } else if (options.page){
      this.redirectForData(key, options);
    }
  },
  redirectForData(key, options){
    options.redirectBack =  options.redirectBack === undefined ? true : options.redirectBack;
    let path = EF.module ? EF.module.currentActivity.currentPage.path() : window.location.hash.replace('#');
    if (options.redirectBack) {
      Chaplin.mediator.subscribeOnce(`enrollment-data-saved:${key}`, () => {
        utils.redirectTo({ url: path });
      });
    }
    utils.redirectTo({ url: options.page });
  }
};

module.exports = EnrollmentDataService;